import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: helpline finder tool (helpline directory cleanup).
export const Route = createFileRoute("/tools/helpline-finder")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
